<script setup lang="ts"></script>

<template>
	<RouterView/>
	<Toast/>
</template>
